var $ = require('jquery');
$(window).on('load', function() {
    changeSearchPlaceholder()
})
$(window).on('resize', function() {
    changeSearchPlaceholder()
})

function changeSearchPlaceholder() {
    if ( $(window).width() <= 855 ) {
        $('.post-list input.facetwp-search').attr('placeholder', 'Search');
    } else {
        $('.post-list input.facetwp-search').attr('placeholder', 'Search news, articles, videos, documents...');
    }
}

$('.post-list__filters-mobile-toggle').on('click', function() {
    if ( $(this).hasClass('post-list__filters-mobile-toggle--open') ) {
        $(this).siblings('.post-list__filters-container').addClass('open');
        let filtersHeight = $('.post-list__filters')[0].scrollHeight;
        $('.post-list__filters').css('max-height', filtersHeight);
    } else if ( $(this).hasClass('post-list__filters-mobile-toggle--close') ) {
        $(this).closest('.post-list__filters-container').removeClass('open');
        $('.post-list__filters').css('max-height', 0);
    } 
    // if ( $(this).closest('.post-list__filter-container').hasClass('open') ) {
    //     $('.post-list__filter-mobile-toggle p').text('Close');
    // } else {
    //     $('.post-list__filter-mobile-toggle p').text('Search and filters');
    // }
})

$('.post-list__filter-mobile-submit .wp-block-button__link').on('click', function() {
    FWP.refresh();
    $('.post-list__filters-container.open').removeClass('open');
    $('.post-list__filters').css('max-height', 0);
})